import React from "react";

const MyTrainers = () => {
  return <div>MyTrainers</div>;
};

export default MyTrainers;
